import { max } from 'date-fns'

const getKycLastUpdate = (kycs) => {
  const datesList = kycs?.map(kyc => new Date(kyc.updated_at)) || []
  return max(datesList)
}

export default getKycLastUpdate
